<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == `${to.meta.abrev}-centro-custo`) {
            next({ name: `${to.meta.abrev}-centro-custo-list` });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == `${this.$route.meta.abrev}-centro-custo`) {
            this.$router.push({ name: `${this.$route.meta.abrev}-centro-custo-list` });
        } 
    },
};
</script>